
export const services = {
  TRANSFER: process.env.REACT_APP_SERVICE_REPUBLICATRANSFER,  
  FRONTEND: process.env.REACT_APP_SERVICE_REPUBLICATRANFERFRONTEND,  
  IDENTITY: process.env.REACT_APP_SERVICE_IDENTITY,  
};
export const endpoints = {
  TRANSFER_FRONTEND_DOWNLOAD: services.FRONTEND + "/dl/{0}",
  TRANSFER_POST_FILE: services.TRANSFER + "/fileshare/{0}/files",
  TRANSFER_GET_FILES: services.TRANSFER + "/fileshare/{0}/files",
  TRANSFER_GET_FILE: services.TRANSFER + "/fileshare/{0}/files/{1}",
  TRANSFER_GET_HISTORY: services.TRANSFER + "/fileshare/transfers",
  TRANSFER_GET_GROUP: services.TRANSFER + "/fileshare/transfers/{0}",
  TRANSFER_DOWNLOAD: services.TRANSFER + "/fileshare/{0}/download",

  TRANSFER_HAS_PERMISSION: services.TRANSFER + "/identity/has-permission",
  GET_USER: services.TRANSFER + "/identity/me",
  IDENTTITY_GET_TOKEN: services.TRANSFER + "/identity/connect/token",
  IDENTTITY_VALIDATE_TOKEN: services.TRANSFER + "/identity/connect/introspect",

  IDENTTITY_REQUEST_RESETCODE: services.IDENTITY + "/sos/resetpasswordgetcode",
  IDENTTITY_RESETPASSWORD_WITHCODE: services.IDENTITY + "/sos/resetpasswordwithcode",  
  IDENTTITY_CREDENTIALS_ME: services.IDENTITY + "/api/credentials/me",
  DEPARTMENTS_ROOT: services.IDENTITY + "/api/departments",
  USER_ROOT: services.IDENTITY + "/api/users",
  USER_SINGLE: services.IDENTITY + "/api/v3/users/{0}",
  USER_SIMPLE: services.IDENTITY + "/api/v3/users/me/simple",
  USER_CUSTOMER_ROLE: services.IDENTITY + "/api/v3/users/{0}/customer/{1}/role/{2}",
  USER_ROLES: services.IDENTITY + "/api/v3/users/roles",

}
export function apiGetParamsReplace(endpoint, ...keys) {

  var result = endpoint;
  keys.forEach(function (key, i) {
    result = result.replace("{" + i + "}", key);
  });
  return result;
}

export const configurations = {
  IDENTITY_GRANT_TYPE: "password",
  IDENTITY_CLIENT_ID: "client",
  IDENTITY_CLIENT_SECRET: "511536EF-F270-4058-80CA-1C89C192F69A",
  IDENTITY_SCOPE: "REPUBLICA_SERVICES",
  IDENTITY_RESOURCE: "RepublicaResource",
};
